import { UserCheck } from 'lucide-react'
import { VisitorsSpaceFields } from '@/components/features/visitors/VisitorsSpaceFields'
import {
  defaultVisitorsConfig,
  mergeVisitorsConfig,
  toVisitorsInput,
  validateVisitorsConfig,
  visitorsConfigApiErrors
} from '@/components/features/visitors/visitorsUtils'
import type { ModuleDefinition } from '../types'
import { lazyPage } from '@/lib/lazyPage'

const VisitorsPage = lazyPage(() => import('@/pages/Visitors'), 'VisitorsPage')

export const visitorsModule: ModuleDefinition = {
  key: 'visitors',
  icon: UserCheck,
  iconName: 'user-check',
  namespaces: ['visitors'],
  ready: true,
  ListPage: VisitorsPage,
  /* Presence link, who registers, fields, e-mails and limit have a body of their own: a third step (PADROES-UI section 14). */
  setup: {
    wizardStep: 'own',
    stepLabelKey: 'visitors:config.stepLabel',
    stepHintKey: 'visitors:config.stepHint',
    defaultConfig: () => defaultVisitorsConfig(),
    validate: (config, t) => validateVisitorsConfig(config, t),
    errorsFromApi: (err) => visitorsConfigApiErrors(err),
    Fields: VisitorsSpaceFields,
    persist: {
      type: 'moduleConfig',
      toModuleConfig: (config, stored) => ({
        ...(stored || {}),
        visitors: { ...(stored?.visitors || {}), ...toVisitorsInput(config) }
      }),
      fromSpace: (space) => mergeVisitorsConfig(space.moduleConfig?.visitors)
    }
  }
}
